import { Module } from "plugins/_application";
import { objectFit } from "../utils/_object-fit";

var $ = jQuery;

export default class ObjectFit extends Module {

    ready(app) {

        objectFit();
    }
}